// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3BKTh","label":"SetPasswdForm_label__1HtK4"};